export default "__VITE_PUBLIC_ASSET__5eb619f4__"